import React from "react";

import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";

import CoursesPic from "../../../images/QTranslate.png";

const CoursesPicContQT = () => {
  return (
    <div className="QL__PG__PGAboutUsSec">
      <Container>
        <Grid container spacing={8}>
          <Grid item xs={12} md={6}>
            <div className="QL__Sec__PGAboutUsmsg">
              <h1 className="HeadingAll">Qur'an Translation</h1>
              <p className="pt-3">
                We know that everyone is not fluent in the Arabic language and
                we are here for the help! LearnQuranQuick will help people
                become proficient in Arabic.
                 {/* Lorem ipsum dolor sit amet,
                consetetur sadipscing elitr, sed diam nonumy eirmod tempor
                invidunt ut labore et dolore magna aliquyam erat, sed diam
                voluptua. At vero eos et accusam etaliquyam erat, sed diam
                voluptua. At vero eos et accusam etaliquyam erat, sed diam
                voluptua. At vero eos et accusam et justo duo dolores et ea
                rebum. Stet clita kasd gubergr.
                <br />
                <br />
                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                diam nonumy eirmod tempor invidunt ut labore et dolore magna
                aliquyam erat, sed diam voluptua. At vero eos et accusam
                etaliquyam erat, sed diam voluptua. At vero eos et accusam
                etaliquyam erat, sed diam voluptua. At vero eos et accusam et
                justo duo dolores et
                <br />
                <br />
                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                diam nonumy eirmod tempor invidunt ut labore et dolore magna
                aliquyam erat, sed diam voluptua. At vero eos et accusam
                etaliquyam erat, sed diam voluptua. At vero eos et accusam
                etaliquyam erat, sed diam voluptua. At vero eos et accusam et
                justo duo dolores et ea rebum.
                <br />
                <br />
                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                diam nonumy eirmod tempor invidunt ut labore et dolore magna
                aliquyam erat, sed diam voluptua. At vero eos et accusam et
                justo duo dolores et ea rebum. Stet clita kasd gubergr. justo
                duo dolores et ea rebum. Stet clita kasd gubergr. At vero eos et
                accusam et justo duo dolores et ea rebum. Stet clita kasd
                gubergr. justo duo dolores et ea rebum. Stet clita kasd gubergr. */}
              </p>
            </div>
          </Grid>
          <Grid item xs={12} md={6}>
            <img src={CoursesPic} alt="image" />
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};
export default CoursesPicContQT;
